import { Plus, Minus } from "@chef/icons/small";
import { ProductsByCategoriesQuery } from "@chef/state-management";
import {
  getPriceOfProductByVariation,
  getStockData,
  getBasketProductQuantity,
} from "@chef/state-management/helpers";
import { useStandaloneBasket } from "@chef/state-management/hooks";
import { IconButton } from "@chef/components";
import { intl } from "./StandaloneProductTile.Intl";

type ControlsProps = {
  variation: ProductsByCategoriesQuery["productsByCategories"][number]["products"][number]["variations"][number];
  basketType: "billing" | "deviation";
  week?: number;
  year?: number;
};

export const Controls = (props: ControlsProps) => {
  const { variation, basketType, week, year } = props;
  const { basket, addToBasket, removeFromBasket } = useStandaloneBasket({
    variant: basketType,
    week,
    year,
  });

  const productId = variation.product.productId;
  const variationId = variation.variationId;
  const price = getPriceOfProductByVariation(variation);
  const productTypeId = variation.product.productTypeId;
  const id = `${productId}:${variationId}`;

  const basketQuantity = getBasketProductQuantity(
    basket,
    productId,
    variationId,
  );

  const { maxPurchasableAmount } = getStockData({
    variation,
    addedQuantity: basketQuantity,
  });

  const onDecrementItem = () => {
    removeFromBasket({
      productId,
      productTypeId,
      variationId,
      price,
    });
  };

  const onIncrementItem = () => {
    addToBasket({
      productId,
      productTypeId,
      variationId,
      price,
    });
  };

  return (
    <div className="relative flex flex-row-reverse justify-between w-20">
      <IconButton
        variant={basketQuantity ? "outlined" : "primary"}
        size="tiny"
        onClick={onIncrementItem}
        id={`${id}-add-btn`}
        disabled={basketQuantity >= maxPurchasableAmount}
        label={intl.ADD}
      >
        <Plus />
      </IconButton>
      {!!basketQuantity && (
        <>
          <IconButton
            variant="default"
            size="tiny"
            onClick={onDecrementItem}
            id={`${id}-minus-btn`}
            label={intl.REMOVE}
          >
            <Minus />
          </IconButton>
          <span className="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            {basketQuantity}
          </span>
        </>
      )}
    </div>
  );
};
